var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "spinner spinner--rotate-square4", style: _vm.styles },
    [_c("span", { staticClass: "loader-inner" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }